import { LiveAppliedBonus } from "./LiveAppliedBonus";

export class NerfAllPlayersBonus extends LiveAppliedBonus {

  constructor () {
    super({
      name: "Cheat Code 18-26",
      value: "nerfAllPlayers",
      icon: "/img/bonus-images/cheat-code.png",
      description: "Bim ! -0,5pt sur chaque joueur adverse, hors gardien. Toujours bon d'avoir des réducs.",
      timing: "afterSubstitutions",
    });
  }

  apply (_, opponentTeam) {
    opponentTeam.pitchPlayers.forEach(player => {
      if (! player.isGoalkeeper()) {
        player.bonusRating -= 0.5;
      }
    });
  }

  revert (_, opponentTeam) {
    opponentTeam.pitchPlayers.forEach(player => {
      if (! player.isGoalkeeper()) {
        player.bonusRating += 0.5;
      }
    });
  }
}